import React, {ChangeEvent, FormEvent, useEffect, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import toast from 'react-hot-toast'
import {BASE_URL} from '../../config'
import {useMutation, useQueryClient} from 'react-query'
import axios from 'axios'
import {handleAxiosError} from '../../../utils/helperFunction/_helper'
import {ICategoryList} from '../core/_model'

type Props = {
  selectedCategory: ICategoryList | null
}

const CREATE_CATEGORY_URL = `${BASE_URL}/api/protect/createKnowledgeCat`
const UPDATE_CATEGORY_URL = `${BASE_URL}/api/protect/updateCategory`

const NewCategoryModal = ({selectedCategory}: Props) => {
  const queryClient = useQueryClient()
  const [categoryName, setCategoryName] = useState('')

  const {mutate: createCategory} = useMutation({
    mutationKey: ['category'],
    mutationFn: async (id: number | null) => {
      if (categoryName) {
        toast.loading('Processing..')
        if (selectedCategory && id) {
          const response = await axios.put(UPDATE_CATEGORY_URL, {categoryId: id, categoryName})
          console.log(response)
        } else {
          const response = await axios.post(CREATE_CATEGORY_URL, {categoryName})
          console.log(response)
        }
      } else {
        console.log('hello')
        toast.error('Please provide category name')
        const error = new Error('Please provide category name') as any
        error.status = 400
        throw error
      }
    },
    onSuccess: (values) => {
      toast.dismiss()
      setCategoryName('')
      toast.success('Successfull')
      queryClient.invalidateQueries(['category'])
    },
    onError: (error) => {
      toast.dismiss()
      console.log(error)
      const message = handleAxiosError(error)
      console.log(message)
      toast.error(message)
    },
  })

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (selectedCategory) {
      await createCategory(selectedCategory.id)
    } else {
      await createCategory(null)
    }
  }

  const onHandleCategoryName = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setCategoryName(value)
  }

  const resetForm = () => {
    setCategoryName('')
  }

  useEffect(() => {
    resetForm()
    if (selectedCategory) {
      setCategoryName(selectedCategory.category_name)
    }
  }, [selectedCategory])

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Add New Category</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <form onSubmit={handleSubmit}>
              <div className='row mb-4'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span className='required'>Category</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    name='category'
                    placeholder='Enter Category'
                    className='form-control form-control-lg form-control custom-input'
                    value={categoryName}
                    onChange={onHandleCategoryName}
                  />
                </div>
              </div>

              {/* <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fs-6'>Description</label>
                <div className='col-lg-8 fv-row-3'>
                  <textarea
                    name='description'
                    placeholder='Enter Description..'
                    className='form-control form-control-lg form-control-solid'
                    rows={5}
                    style={{resize: 'vertical', fontSize: '1.0rem'}}
                    required
                  ></textarea>
                </div>
              </div> */}

              {/* <div className='row mb-4'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span className='required'>Order</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    name='order'
                    placeholder='Enter order'
                    className='form-control form-control-lg form-control-solid'
                    required
                  />
                </div>
              </div> */}

              {/* <div className='row mb-4 align-items-center'>
                <label className='col-lg-4 col-form-label fs-6'>
                  <span>Status</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <div className='form-check form-switch form-check-custom form-check-solid'>
                    <input name='status' className='form-check-input' type='checkbox' />
                  </div>
                </div>
              </div> */}

              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  className='btn btn-light me-4'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                  onClick={resetForm}
                >
                  Close
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  Add Category
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewCategoryModal
